import React from "react";
import {
  FormControlLabel,
  FormGroup,
  Checkbox as MuiCheckbox,
  FormHelperText,
} from "@mui/material";

export default function InputCheck(props) {
  const {
    label,
    checked,
    defaultChecked,
    name,
    onChange,
    size = "medium",
    error = null,
    variant = "checkbox-primary",
    className,
    ...other
  } = props;
  return (
    <FormGroup className="w-fit">
      <FormControlLabel
        label={label}
        onChange={onChange}
        className={`${variant} ${className} text-gray-600`}
        name={name}
        control={
          <MuiCheckbox
            size={size}
            checked={checked}
            defaultChecked={defaultChecked}
            className="p-[5px]"
          />
        }
        sx={{
          userSelect: "none",
          WebkitUserSelect: "none",
          MozUserSelect: "none",
          msUserSelect: "none",
        }}
        {...other}
      />
      {error && (
        <FormHelperText className="color-danger">{error}</FormHelperText>
      )}
    </FormGroup>
  );
}
